import { createFileRoute } from '@tanstack/react-router';
import TagAssociationTypes from 'containers/TagAssociationTypes';

export const Route = createFileRoute('/_authenticated/tagAssociationTypes')({
  component: TagAssociationTypes,
});
